<script lang="ts" setup>

// ---------------------------------------
// Composables
// ---------------------------------------
const { t } = useI18n();

const { data } = useAsyncData(
  'home_events',
  () => $fetch('/api/events?page=1&per_page=4&order_by=date&order_dir=asc'),
);

</script>
<template>
  <section v-if="data?.docs" class="max-w-max py-32 px-4 md:p-10 lg:p-9">
    <div class="max-w-container-ws mx-auto">
      <span class="block my-5 uppercase">
        {{ $t('CALENDAR') }}
      </span>

      <h3 class="text-2xl md:text-4xl font-bold w-full mb-8 mt-3">
        {{ $t('EVENTS') }}
      </h3>
      <div>
        <ul class="flex flex-col">
          <EventsCardList
            v-for="event in data.docs"
            :key="event.id"
            :date="event.date"
            :description="event.description"
            :title="event.title"
            :location="event.location"
            :start-at="event.date"
            :end-at="event.date"
            :show-img="true"
          />
        </ul>
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
section {
  max-width: unset !important;
  background-color: #f2f0ef;
}
</style>